import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";

import { getSelectedAccount } from "containers/Accounts/reducer";

import ModelTileContainer from "containers/Tiles/ModelTile";
import MiniDeploy from "containers/Deploy/MiniDeploy";

import Contest from "components/Contest/Contest";

class ContestContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { showFeatures: false, modelIndex: 0 };
  }

  render() {
    const { history, models, deploy, id } = this.props;
    const { modelIndex } = this.state;

    const maxIteration = models && models[0] && models[0].maxIteration ? models[0].maxIteration : {};
    const metrics = models && models[0] && models[0].metrics ? models[0].metrics : {};

    const secondIndex = modelIndex !== 0 ? modelIndex + 1 : 1;

    let features = [];

    if (models[0] && models[secondIndex] && models[0].featureInfo && models[secondIndex].featureInfo) {
      for (let feature of models[0].featureInfo) {
        const rightFeature = models[secondIndex].featureInfo.filter((f) => f.label === feature.label)[0];
        const rightScore = rightFeature ? rightFeature.score : 0;

        features.push({
          left: feature.score,
          right: rightScore,
          label: feature.label,
          delta: rightScore - feature.score,
          leftModel: models[0].id,
          rightModel: models[secondIndex].id,
          values: feature.values
        });
      }
    }

    features = features.sort((a, b) => Math.abs(b.left) + Math.abs(b.right));

    const model =
      models.filter((m) => m.id !== "Current State").length > 0
        ? models.filter((m) => m.id !== "Current State")[0]
        : undefined;

    return (
      <Contest
        {...this.props}
        model={model}
        models={models.map((model, index) => (
          <ModelTileContainer
            model={model}
            id={id}
            key={model.id}
            isContest={true}
            showFeatures={this.state.showFeatures}
            hasLeft={index > 1}
            hasRight={index !== 0 && index < models.length - 1}
            updateModelIndex={(delta) => this.setState({ modelIndex: delta === 0 ? 0 : this.state.modelIndex + delta })}
          />
        ))}
        deployContainer={deploy ? <MiniDeploy id={id} modelId={deploy} /> : undefined}
        metrics={metrics}
        maxIteration={maxIteration}
        features={features}
        handleUpdateShowFeatures={(sf) => this.setState({ showFeatures: sf })}
        modelIndex={this.state.modelIndex}
        showFeatures={this.state.showFeatures}
        updateModelIndex={(delta) => this.setState({ modelIndex: delta === 0 ? 0 : this.state.modelIndex + delta })}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = ownProps.id ? ownProps.id : -1;

  return {
    init: (jobID, isProd) => dispatch(runReducer.init(jobID, isProd)),
    updateHideCosts: (hideCosts) => dispatch(setupReducer.updateHideCosts(id, hideCosts)),

    updateConversionGain: (conversionGain) => dispatch(setupReducer.updateConversionGain(id, conversionGain)),
    updateConversionCost: (conversionCost) => dispatch(setupReducer.updateConversionCost(id, conversionCost)),

    updateCostSliderRatio: (costSliderRatio) => dispatch(setupReducer.updateCostSliderRatio(id, costSliderRatio))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id ? ownProps.id : -1;

  const selectedAccount = getSelectedAccount(state);

  return {
    id: id,

    models: runReducer.getTransformedSortedModels(state, id, true),

    isDone: runReducer.getIsDone(state, id),

    labels: setupReducer.getLabels(state, id),

    hideCosts: setupReducer.getHideCosts(state, id),
    processLimit: setupReducer.getProcessLimit(state, id),
    isQuickRun: setupReducer.getIsQuickRun(state, id),
    isTwoMinuteRun: setupReducer.getIsTwoMinuteRun(state, id),
    isContinuous: runReducer.getIsContinuous(state, id),

    conversionGain: setupReducer.getConversionGain(state, id),
    conversionCost: setupReducer.getConversionCost(state, id),

    costSliderRatio: setupReducer.getCostSliderRatio(state, id),

    runCost: runReducer.getRunCost(state, id),

    serverProgress: runReducer.getServerProgress(state, id),
    notebookProgress: runReducer.getNotebookProgress(state, id),

    deploy: runReducer.getDeploy(state, id),

    netImpactLabel: setupReducer.getNetImpactLabel(state, id),

    isError: runReducer.getIsError(state, id),
    errors: runReducer.getErrors(state, id),

    isAzure: selectedAccount && selectedAccount.type === "AZURE"
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ContestContainer);
